import { IReactFlowData } from '@query'

export const EMPTY_FLOW: IReactFlowData = {
  nodes: [],
  edges: []
}
